
export const KycDetailsTableHeading = (t) => {
    const Heading = [
        { title: t("RequestId"), field: "booking_id" },
        { title: t("AgreementId"), field: "agreement_no" },
        { title: t("RequestBy"), field: "requested_by" },
        { title: t("RequestOn"), field: "requested_on" },
        { title: t("ContactId"), field: "contact_id" },
        { title: t("Name"), field: "name" },
        { title: t("Mobile"), field: "mobile" },
        { title: t("Email"), field: "email" },
        { title: t("NoofProof"), field: "no_of_proof" },
        { title: t("ApprovedProofCount"), field: "no_of_approved_count" },
        { title: t("Status"), field: "status" },
        { title: t("DateClosed"), field: "date_closed" },
    ]
    return Heading
}

export const KycDetailsTablePath = [
    "booking_id",
    "agreement_no",
    "requested_by",
    "requested_on",
    "contact_id",
    "name",
    "mobile",
    "email",
    "no_of_proof",
    "no_of_approved_count",
    "status",
    "date_closed"
]

export const KycDetailsTableDataType = [
    { type: ["text"], name: "booking_id" },
    { type: ["text"], name: "agreement_no" },
    { type: ["text"], name: "requested_by" },
    { type: ["text"], name: "requested_on" },
    { type: ["text"], name: "contact_id" },
    { type: ["text"], name: "name" },
    { type: ["text"], name: "mobile" },
    { type: ["text"], name: "email" },
    { type: ["text"], name: "no_of_proof" },
    { type: ["text"], name: "no_of_approved_count" },
    { type: ["kyc_status"], name: "status" },
    { type: ["text"], name: "date_closed" },
]



export const KycDetailViewTableHeading = (t) => {
    const Heading = [
        { title: t("ContactId"), field: "contact_id" },
        { title: t("contactName"), field: "contact_name" },
        { title: t("IDType"), field: "id_type" },
        { title: t("NameAsPerID"), field: "name_as_per_id" },
        { title: t("IDNumber"), field: "id_number" },
        { title: t("Mandatory"), field: "mandatory" },
        { title: t("validatity"), field: "validatity" },
        { title: t("Verified"), field: "verified_text" },
        { title: t("source"), field: "source" },
        { title: t("Status"), field: "status" }
    ]
    return Heading
}
export const KycDetailViewTablePath = [
    "contact_id",
    "contact_name",
    "id_type",
    "name_as_per_id",
    "id_number",
    "mandatory",
    "validatity",
    "verified_text",
    "verified",
    "source",
    "status"
]

export const KycDetailViewTableDataType = [
    { type: ["text"], name: "contact_id" },
    { type: ["text"], name: "contact_name" },
    { type: ["text"], name: "id_type" },
    { type: ["text"], name: "name_as_per_id" },
    { type: ["text"], name: "id_number" },
    { type: ["text"], name: "mandatory" },
    { type: ["text"], name: "validatity" },
    { type: ["text"], name: "verified_text" },
    { type: ["text"], name: "source" },
    { type: ["kyc_status"], name: "status" }
]

export const Mandatory = (t) => [
    { label: t('Yes'), value: true },
    { label: t('No'), value: false },
]